RivalIQ.apps.AccountSettings.module('views', function (views, App, Backbone, Marionette, $, _, planUpgrades) {

    'use strict';

    function formatCurrency(val, decimals) {
        return val.toLocaleString('en-us', {
            style: 'currency',
            currency: 'USD',
            minimumFractionDigits: decimals ? 2 : 0
        });
    }

    const PlanVariantView = Marionette.ItemView.extend({
        modelEvents: {
            'change': 'render'
        },
        templateHelpers: function () {
            const me = this;
            const type = me.options.type;
            const index = me.model.get('selectedIndex');

            return {
                planVariant: me.augmentPlanVariant(me.model.get(type)[index]),
                purchaseRestriction: RivalIQ.enums.plan.purchaseRestriction,
                formatCurrency: formatCurrency,
                formatLabeledNumber: RivalIQ.formatter.formatLabeledNumber,
                getRestrictionMessage: function (planVariant, companies, savedSearches, formatLabeledNumber) {
                    let restrictionMessagePart1;
                    let restrictionMessagePart2;
                    if (planVariant.kind === 'drive') {
                        if (companies > planVariant.max_companies && savedSearches > planVariant.max_listening_saved_searches) {
                            restrictionMessagePart1 = RivalIQ.str('downgrade_plan_fewer_companies_no_topics');
                            restrictionMessagePart2 = RivalIQ.str('downgrade_plan_unfollow_x_companies_remove_all_topics', formatLabeledNumber('company', 'companies', companies - planVariant.max_companies));
                        } else if (companies > planVariant.max_companies) {
                            restrictionMessagePart1 = RivalIQ.str('downgrade_plan_fewer_companies');
                            restrictionMessagePart2 = RivalIQ.str('downgrade_plan_unfollow_x_companies', formatLabeledNumber('company', 'companies', companies - planVariant.max_companies));
                        } else if (savedSearches > planVariant.max_listening_saved_searches) {
                            restrictionMessagePart1 = RivalIQ.str('downgrade_plan_no_topics');
                            restrictionMessagePart2 = RivalIQ.str('downgrade_plan_remove_all_topics');
                        }
                    } else {
                        if (companies > planVariant.max_companies && savedSearches > planVariant.max_listening_saved_searches) {
                            restrictionMessagePart1 = RivalIQ.str('downgrade_plan_fewer_companies_and_topics');
                            restrictionMessagePart2 = RivalIQ.str('downgrade_plan_unfollow_x_companies_remove_x_topics', formatLabeledNumber('company', 'companies', companies - planVariant.max_companies), formatLabeledNumber('topic', 'topics', savedSearches - planVariant.max_listening_saved_searches));
                        } else if (companies > planVariant.max_companies) {
                            restrictionMessagePart1 = RivalIQ.str('downgrade_plan_fewer_companies');
                            restrictionMessagePart2 = RivalIQ.str('downgrade_plan_unfollow_x_companies', formatLabeledNumber('company', 'companies', companies - planVariant.max_companies));
                        } else if (savedSearches > planVariant.max_listening_saved_searches) {
                            restrictionMessagePart1 = RivalIQ.str('downgrade_plan_fewer_topics');
                            restrictionMessagePart2 = RivalIQ.str('downgrade_plan_remove_x_topics', formatLabeledNumber('topic', 'topics', savedSearches - planVariant.max_listening_saved_searches));
                        }
                    }
                    return `${restrictionMessagePart1}<br/><br/>${restrictionMessagePart2}`;
                }
            };
        },
        augmentPlanVariant: _.identity
    });

    views.PlanBuyButton = PlanVariantView.extend({
        template: '#subscriptionPlanBuyButton',
        events: {
            'click .x-purchase': 'onPurchaseClicked',
            'click .x-contact-us': 'onContactUs'
        },

        augmentPlanVariant: function (planVariant) {
            const restrictions = RivalIQ.enums.plan.purchaseRestriction;
            const distinct = _.get(RivalIQ.state.account.get('companyLimits'), ['distinct']);

            if (distinct > 0 && distinct > planVariant.max_companies && planVariant.purchaseRestriction === restrictions.NONE) {
                planVariant.purchaseRestriction = restrictions.OVER_COMPANY_LIMIT;
            }

            return planVariant;
        },

        serializeData: function () {
            return {
                companies: _.get(RivalIQ.state.account.get('companyLimits'), ['distinct'], 0),
                savedSearches: RivalIQ.state.account.get('listeningSavedSearchCount'),
                trial: RivalIQ.state.account.isTrialing(),
                cancelled: RivalIQ.state.account.isCancelled()
            };
        },

        onPurchaseClicked: function (e) {
            const planId = Number($(e.currentTarget).data('id'));
            const plan = RivalIQ.state.product.getPlanById(planId);
            const currPlan = RivalIQ.state.account.get('plan');
            const isRepurchaseAfterChurn = RivalIQ.state.account.isCancelled();
            const handlerToExecute = (isRepurchaseAfterChurn ? 'payment:start' : 'payment:planChange');
            let discountPrice = plan.price;

            if (RivalIQ.payment.shouldApplyCoupon(RivalIQ.state.account.get('currentStripeCoupon'), plan)) {
                discountPrice *= (1 - RivalIQ.state.account.get('currentStripeCoupon').discount);
            }

            // For users who are trialing or cancelled, we don't want to show the plan change warning modal, just take
            // then straight to the CC entry modal.
            const isTrialingOrCancelled = RivalIQ.state.account.isTrialing() || RivalIQ.state.account.isCancelled();

            if (!RivalIQ.state.account.get('accountEmailVerifiedAt')) {
                RivalIQ.execute('show:modal', new App.views.EmailVerificationModal());
            } else if (!isTrialingOrCancelled && !currPlan.annual && !plan.annual) {
                // warn monthly to monthly plan upgrade
                RivalIQ.execute('show:modal', new App.views.PlanChangeToMonthlyModal({
                    plan: plan,
                    price: discountPrice,
                    handlerToExecute: handlerToExecute
                }));
            } else if (!isTrialingOrCancelled && plan.annual) {
                // NOTE if the new plan is annual, they will be charged right away, so warn them first
                RivalIQ.execute('show:modal', new App.views.PlanChangeToAnnualModal({
                    plan: plan,
                    price: discountPrice,
                    handlerToExecute: handlerToExecute
                }));
            } else {
                RivalIQ.execute(handlerToExecute, {
                    plan: plan
                });
            }

            RivalIQ.execute('tracking:push:auth', RivalIQ.tracking.metric.ClickedSubscribeButton, {
                planId: planId,
                planName: plan.name,
                annual: plan.annual
            });
        },

        onContactUs: function (e) {
            if (window.Intercom) {
                window.Intercom('show');
            } else {
                const $trigger = $(e.currentTarget);
                RivalIQ.execute('show:modal', new RivalIQ.apps.Shell.views.ContactUsModal({
                    model: new Backbone.Model({
                        context: $trigger.data('context')
                    })
                }));
            }
        }
    });

    views.PlanPricing = PlanVariantView.extend({
        template: '#subscriptionPlanPricing'
    });

    views.PlanBill = PlanVariantView.extend({
        template: '#subscriptionPlanBill'
    });

    const PlanDetailsModal = RivalIQ.views.ItemView.extend({
        className: 'modal fade',
        template: '#subscriptionDetailsnModal',

        ui: {
            modal: '.modal'
        },

        onShow: function () {
            const me = this;
            me.ui.modal.modal({
                keyboard: true
            });
        }
    });

    const AllFeaturesModal = RivalIQ.views.ItemView.extend({
        className: 'modal fade',
        template: '#allFeaturesModal',

        ui: {
            modal: '.modal'
        },

        onShow: function () {
            const me = this;
            me.showPopovers();
            me.ui.modal.modal({
                keyboard: true
            });
        },

        showPopovers: function () {
            const me = this;

            me.$('[data-toggle="popover"]').each(function () {
                const $el = $(this);
                const trigger = $el.data('trigger');

                if (trigger === 'hover-sticky') {
                    return $el.popover({
                        trigger: 'manual',
                        html: true
                    })
                        .on('mouseenter', function () {
                            const _this = this;
                            $(_this).popover('show');
                            $('.popover').on('mouseleave', function () {
                                $(_this).popover('hide');
                            });
                        })
                        .on('mouseleave', function () {
                            const _this = this;
                            setTimeout(function () {
                                if (!$('.popover:hover').length) {
                                    $(_this).popover('hide');
                                }
                            }, 300);
                        });
                }

                $el.popover({
                    html: true
                });
            });
        }
    });

    views.Subscription = RivalIQ.views.ItemView.extend({

        template: false,

        ui: {
            changePlanMsg: '.x-change-plan-msg',
            changePlanBtn: '.x-change-plan',
            cancelModalBtn: '.x-cancel-plan-modal',
            restoreBtn: '.x-restore-plan',
            cancelPlanBtnTooltip: '.x-cancel-plan-button-tooltip',
            cancelModal: '#cancelModal',
            planSelector: 'select.max-companies',
            planBuyButton: '.x-plan-buy-button-container',
            csm: '.x-csm-details',
            viewAllDetails: '.x-view-all-details',
            seeAllFeatures: '.x-see-all-features',
            planPrice: '.x-plan-price-container',
            planBill: '.x-plan-bill-container'
        },

        events: {
            'click .x-update-card': 'onUpdateCard',
            'click .x-restore-plan': 'onPlanRestoreClicked',
            'click .x-cancel-plan-modal': 'showCancelModal',
            'change @ui.planSelector': 'onPlanSelect',
            'click @ui.viewAllDetails': 'onViewPlanDetails',
            'click @ui.seeAllFeatures': 'onSeeAllFeatures',
            'click .x-add-more-companies': 'onOpenAddCompaniesModal'
        },

        modelEvents: {
            'change:selfChurned': 'onChurnStatusChanged'
        },

        initialize: function () {
            const me = this;

            me.planGroups = {};

            _.each(planUpgrades, function (planGroup) {
                const kind = _.get(planGroup, ['annual', 0, 'kind']) || _.get(planGroup, ['monthly', 0, 'kind']);
                const selectedIndex = _.reduce(['annual', 'monthly'], function (memo, duration) {
                    _.each(_.get(planGroup, [duration]), function (planVariant, index) {
                        if (planVariant.purchaseRestriction === RivalIQ.enums.plan.purchaseRestriction.CURRENT_PLAN) {
                            memo = index;
                        }
                    });
                    return memo;
                }, 0);

                const data = _.extend({
                    selectedIndex: selectedIndex
                }, planGroup);
                $(`select[data-kind=${kind}]`).val(selectedIndex);
                me.planGroups[kind] = new Backbone.Model(data);
            });
        },

        onPlanSelect: function (e) {
            const me = this;

            const kind = $(e.currentTarget).data('kind');
            const index = $(e.currentTarget).val();
            me.planGroups[kind].set('selectedIndex', parseInt(index));

            me.$el.find(`select[data-kind=${kind}]`).val(me.planGroups[kind].get('selectedIndex'));
            me.requestRenderedFrame(function () {
                me.showPopovers();
            });
        },

        showPopovers: function () {
            const me = this;

            me.$('[data-toggle="popover"]').each(function () {
                const $el = $(this);
                const trigger = $el.data('trigger');

                if (trigger === 'hover-sticky') {
                    return $el.popover({
                        trigger: 'manual',
                        html: true
                    })
                        .on('mouseenter', function () {
                            const _this = this;
                            $(_this).popover('show');
                            $('.popover').on('mouseleave', function () {
                                $(_this).popover('hide');
                            });
                        })
                        .on('mouseleave', function () {
                            const _this = this;
                            setTimeout(function () {
                                if (!$('.popover:hover').length) {
                                    $(_this).popover('hide');
                                }
                            }, 300);
                        });
                }

                $el.popover({
                    html: true
                });
            });
        },

        showCancelModal: function () {
            const me = this;
            RivalIQ.execute('show:modal', new App.views.ChurnModal({
                model: new App.models.Churn({
                    accountId: RivalIQ.state.account.get('id'),
                    plan: me.model.get('plan'),
                    isAgency: me.model.get('isAgency'),
                    hasDiscount: me.model.get('hasDiscount')
                })
            }));
        },

        onChurnStatusChanged: function (model, selfChurned) {
            const me = this;
            me.ui.restoreBtn.toggle(selfChurned);
            me.ui.cancelModalBtn.toggle(!selfChurned && RivalIQ.state.user.can('update', 'Payment'));
            me.updatePlanBtns();
        },

        onPlanRestoreClicked: function () {
            const me = this;

            me.ui.restoreBtn.button('loading');

            const reactivate = new App.models.Reactivate({
                accountId: RivalIQ.state.account.get('id')
            });

            reactivate.save()
                .done(function () {
                    RivalIQ.execute('alert:info', 'Your account has been re-established! <br> If you have any questions, please contact support.');
                    me.ui.restoreBtn.button('reset');
                    RivalIQ.state.account.set('selfChurned', false);
                    RivalIQ.execute('tracking:push:auth', RivalIQ.tracking.metric.SelfReactivated);

                    setTimeout(function () {
                        window.location.reload();
                    }, 2000);
                })
                .fail(function () {
                    me.ui.restoreBtn.button('reset');
                    RivalIQ.execute('alert:danger', 'An error occurred submitting your request. Please try again');
                });
        },

        showPlanVariantViews: function (uiElems, ViewClass) {
            const me = this;

            _.each(uiElems, function (el) {
                const kind = $(el).data('kind');
                const type = $(el).data('type');
                const view = new ViewClass({
                    el: el,
                    type: type,
                    model: me.planGroups[kind]
                });
                view.render();
            });
        },

        showPlanPrice: function () {
            const me = this;
            me.showPlanVariantViews(me.ui.planPrice, views.PlanPricing);
        },

        showPlanBill: function () {
            const me = this;
            me.showPlanVariantViews(me.ui.planBill, views.PlanBill);
        },


        showPlanBuyButton: function () {
            const me = this;

            me.showPlanVariantViews(me.ui.planBuyButton, views.PlanBuyButton);
        },

        showCsmDetails: function () {
            const me = this;

            const CsmDetailsView = new views.CsmDetails({
                el: me.ui.csm
            });
            CsmDetailsView.render();
        },

        onViewPlanDetails: function () {
            RivalIQ.execute('show:modal', new PlanDetailsModal());
        },

        onSeeAllFeatures: function () {
            RivalIQ.execute('show:modal', new AllFeaturesModal());
        },

        onOpenAddCompaniesModal: function () {
            RivalIQ.execute('show:modal', new RivalIQ.landscape.views.AddCompaniesModal({
                model: new Backbone.Model({
                    showAddCompanyModal: false,
                    credits: RivalIQ.state.account.get('companyLimits'),
                    reloadOnSuccess: true,
                    page: 'subscription'
                })
            }));
        },

        onShow: function () {
            const me = this;

            me.showPlanPrice();
            me.showPlanBill();
            me.showPlanBuyButton();
            me.showCsmDetails();

            const plan = RivalIQ.state.account.get('plan');

            // NOTE if the account is scheduled to churn, but not yet churned, let them undo it
            if (RivalIQ.state.account.churned() && !RivalIQ.state.account.isCancelled()) {
                me.updatePlanBtns();
                me.ui.restoreBtn.show();
            } else if (RivalIQ.state.account.isPaid() && !plan.annual &&
                       RivalIQ.state.user.can('churn', RivalIQ.state.account)) {

                me.ui.cancelModalBtn.show();
            } else {
                me.ui.cancelModalBtn.show();
                me.ui.cancelModalBtn.toggleClass('disabled', true);
                if (RivalIQ.state.user.getRole().get('id') !== RivalIQ.enums.roles.owner.id) {
                    me.ui.cancelPlanBtnTooltip.popover({
                        content: RivalIQ.str('reason_for_non_owner_user_cant_cancel_subscription')
                    });
                } else if (plan.annual) {
                    me.ui.cancelPlanBtnTooltip.popover({
                        content: RivalIQ.str('reason_for_annual_subscription_cant_cancel_online')
                    });
                }
            }

            me.showPopovers();
        },

        updatePlanBtns: function () {
            const me = this;

            if (RivalIQ.state.account.churned()) {
                me.ui.changePlanBtn.attr({
                    disabled: true
                });
                me.ui.changePlanMsg.text('You cannot change plans until you reactivate your account');
            } else {
                me.ui.changePlanBtn.attr({
                    disabled: false
                });
                me.ui.changePlanMsg.text('');
            }
        },

        onUpdateCard: function () {
            RivalIQ.execute('payment:start', {
                updateCard: true,
                plan: RivalIQ.state.account.get('plan')
            });
        }
    });

    views.CsmDetails = RivalIQ.views.ItemView.extend({
        template: '#csmDetailsTemplate',

        serializeData: function () {
            const plan = RivalIQ.state.account.get('plan');
            const email = plan.has_quid_compete_branding ? 'support@quid.com' : 'support@rivaliq.com';

            return {
                title: 'Customer Success Team',
                email: email,
                trainingVideosUrl: 'https://www.rivaliq.com/training-webinars/'
            };
        }
    });

}, window.planUpgrades);
